import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MixpanelService } from '../../services/mixpanel.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  listIcons = [
    // {
    //   icon: '#ic-instagram',
    //   link: 'https://www.instagram.com/vinho.bid/',
    // }, {
    //   icon: '#ic-facebook',
    //   link: 'https://www.facebook.com/vinhobid',
    // }, {
    //   icon: '#ic-linkedin',
    //   link: 'https://www.linkedin.com/company/vinhobid',
    // }, {
    //   icon: '#ic-youtube',
    //   link: '',
    // }
  ];

  window: any;

  constructor(@Inject(DOCUMENT) private _document, private mixpanel: MixpanelService) {
    this.window = _document.defaultView
  }

  ngOnInit(): void { }

  openContact() {
    this.window.FrontChat('show');
  }

  onRouteClick(title: string, link: string): void {
    this.mixpanel.track(`Rodapé | ${title}`, {
      item: title,
      rota: link
    });

    this.window.location.href = link;
  }
}
